'use client';
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import EmotionCacheProvider from '@local/ui/EmotionCache';
import theme from '@almacareer/profesiaui/styles/theme';

export default function ThemeRegistry({ children }: React.PropsWithChildren) {
    return (
        <EmotionCacheProvider options={{ key: 'mui' }}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </EmotionCacheProvider>
    );
}
